import CustomLoader, { Sizes } from 'components/BouncyBarsLoader/BouncyBarsLoader';
import useBearPriceInEstimatedTWAP from 'hooks/useBearPriceInEstimatedTWAP';
import useCashPriceInEstimatedTWAP from 'hooks/useCashPriceInEstimatedTWAP';
import React, { useMemo } from 'react';
import CountUp from 'react-countup';
import { TiWarning } from 'react-icons/ti';
import CustomBtn from 'uikit/BtnComponent';
import OutlineBtn from 'uikit/OutlineComponent';
import { noop } from 'utils/utils';
import scrubcasino from 'assets/tokenImg/scrubmoney.jpg';
import bearLogo from 'assets/tokenImg/bear.png';
import lionLogo from 'assets/tokenImg/lion.png';
import tigerLogo from 'assets/tokenImg/tiger.png';
import lionPayLogo from 'assets/tokenImg/lionpay.png';
import lionFundLogo from 'assets/img/lionFundLogo.png';
import lionNFTLogo from 'assets/img/lionNFTLogo.jpeg';
import lionSingleStakeLogo from 'assets/img/lionNFTLogo.jpeg';

import lionFundLogoBack from 'assets/img/lionFundLogoBack.png';
import scrubLogo from 'assets/tokenImg/scrubLogo.png';
import scrubDexi from 'assets/tokenImg/scrubDexi.jpg';
import lionBombLogo from 'assets/img/lionbomb.png';
import usdcBombLogo from 'assets/img/usdcbomb.png';
import kavaLogo from 'assets/img/kavamigrator.png';
import lionCave from 'assets/tokenImg/lioncave.png';
import lionGiftcard from 'assets/img/giftcard.jpg';
import bybitBanner from 'assets/img/bybitbanner.png';

import useBearStats from '../../hooks/useBearStats';
import useLpStats from '../../hooks/useLpStats';
import useTombStats from '../../hooks/useTombStats';
import useTotalValueLocked from '../../hooks/useTotalValueLocked';
import usetShareStats from '../../hooks/usetShareStats';
import {
  ADDBtn,
  ADDBtns,
  BuyBtn,
  BuyBtns,
  BuyLeft,
  BuyRight,
  CardImg,
  CardMoney,
  CardTbl,
  CardTblLabel,
  CardTitle,
  CardTopDiv,
  HomeBody,
  HomeImg,
  HomeOut,
  LionCard,
  LionCards,
  LionCardsOut,
  List,
  Lists,
  Num,
  SVNCards,
  SubText,
  Text,
  Title,
  TotalNumber,
  TotalText,
  WarIcon,
  WarningPart,
  News,
  LionColumn,
  LionRow,
  CardImgSmall,
} from './home.style';
import { formatNumber } from './home.utils';
import { CText, HomeBack } from 'views/Commerce/commerce.style';
import { TopText } from 'views/Pit/bond.style';
import { Link } from 'react-router-dom';
import useLionBombInfo from 'hooks/useLionBombInfo';
import { getDisplayBalance } from 'utils/formatBalance';
import { BigNumber } from 'ethers';
import ProgressCountdown from 'views/Masonry/components/ProgressCountdown';
import moment from 'moment';
import { green } from 'theme/colors';
import { Bold } from 'react-feather';
import useTombFinance from 'hooks/useTombFinance';
import useChainId from 'hooks/useChainId';
import useTinBalance from 'hooks/useTinBalance';

export default function HomeContainer() {
  class TinWidget extends React.Component {
    componentDidMount() {
      const script = document.createElement('script');
      script.body =
        "(function (w, d, s, o, f, js, fjs) {\
        w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments) };\
        js = d.createElement(s), fjs = d.getElementById(o + '-widget');\
        js.id = o; js.src = f; js.async = 1; fjs.parentNode.insertBefore(js, fjs);\
      }(window, document, 'script', 'tin', 'https://api.tin.network/widget/widget.js'));\
      \
      tin('init', {{\
        address: ´0x932A3FE07002D0B98A2Dec0B70beE186b0b37c80´,\
        expand: false,\
        darkTheme: true\
      }});";

      script.async = false;
      script.defer = false;
      script.document.body.appendChild(script);
    }
    render() {
      return (
        <div id="tin-widget">
          <div id="mycustom-container"> </div>
        </div>
      );
    }
  }
  const chainId = useChainId();
  const tombFinance = useTombFinance();
  const TVL = useTotalValueLocked();
  const tombStats = useTombStats();
  const bearStats = useBearStats();
  const tShareStats = usetShareStats();

  const tombFtmLpStats = useLpStats('LION-USDT-LP');
  const tShareFtmLpStats = useLpStats('TIGER-LION-LP');
  const bearBtcLpStats = useLpStats('BEAR-WBTC-LP');

  //const tinBalance = useTinBalance();
  const tinBalance = 200152;
  const tombLPStats = useMemo(() => (tombFtmLpStats ? tombFtmLpStats : null), [tombFtmLpStats]);
  const tshareLPStats = useMemo(() => (tShareFtmLpStats ? tShareFtmLpStats : null), [tShareFtmLpStats]);
  const bearLPStats = useMemo(() => (bearBtcLpStats ? bearBtcLpStats : null), [bearBtcLpStats]);
  const tombPriceInDollars = useMemo(
    () => (tombStats ? Number(tombStats.priceInDollars).toFixed(6) : null),
    [tombStats],
  );
  const tombPriceInFTM = useMemo(() => (tombStats ? Number(tombStats.tokenInFtm).toFixed(4) : null), [tombStats]);
  const tombCirculatingSupply = useMemo(() => (tombStats ? String(tombStats.circulatingSupply) : null), [tombStats]);
  const tombTotalSupply = useMemo(() => (tombStats ? String(tombStats.totalSupply) : null), [tombStats]);

  const bearCirculatingSupply = useMemo(() => (bearStats ? String(bearStats?.circulatingSupply) : null), [bearStats]);
  const bearTotalSupply = useMemo(() => (bearStats ? String(bearStats?.totalSupply) : null), [bearStats]);
  const bearPriceInDollars = useMemo(
    () => (bearStats ? Number(bearStats?.priceInDollars).toFixed(6) : null),
    [bearStats],
  );

  const tSharePriceInDollars = useMemo(
    () => (tShareStats ? Number(tShareStats.priceInDollars).toFixed(6) : null),
    [tShareStats],
  );
  const tSharePriceInFTM = useMemo(
    () => (tShareStats ? Number(tShareStats.tokenInFtm).toFixed(6) : null),
    [tShareStats],
  );
  const tShareCirculatingSupply = useMemo(
    () => (tShareStats ? String(tShareStats.circulatingSupply) : null),
    [tShareStats],
  );
  const tShareTotalSupply = useMemo(() => (tShareStats ? String(tShareStats.totalSupply) : null), [tShareStats]);

  const cashStat = useCashPriceInEstimatedTWAP();
  const scalingFactorLion = useMemo(() => (cashStat ? Number(cashStat.priceInDollars).toFixed(4) : null), [cashStat]);

  const lionBomb = tombFinance.contracts['lionbomb'];
  const usdcBomb = tombFinance.contracts['usdcbomb'];
  const lionBombInfo = useLionBombInfo(lionBomb);
  const usdcBombInfo = useLionBombInfo(usdcBomb);

  const lionBombJackpot = useMemo(() => {
    return lionBombInfo.jackpot ? getDisplayBalance(BigNumber.from(lionBombInfo.jackpot), 18, 2) : 0;
  }, [lionBombInfo]);
  const lionBombJackpotUSDC = useMemo(() => {
    return lionBombInfo.jackpot && tombPriceInFTM
      ? formatNumber(getDisplayBalance(BigNumber.from(lionBombInfo.jackpot), 18, 2) * tombPriceInFTM)
      : '--';
  }, [lionBombInfo, tombPriceInFTM]);
  const lionBombTime = useMemo(() => {
    const date = new Date(0);
    if (lionBombInfo.epochFinish) {
      date.setUTCSeconds(Number(lionBombInfo.epochFinish));
      return date;
    } else {
      return date;
    }
  }, [lionBombInfo]);

  const usdcBombJackpot = useMemo(() => {
    return usdcBombInfo.jackpot ? getDisplayBalance(BigNumber.from(usdcBombInfo.jackpot), 6, 2) : 0;
  }, [usdcBombInfo]);

  const usdcBombTime = useMemo(() => {
    const date = new Date(0);
    if (usdcBombInfo.epochFinish) {
      date.setUTCSeconds(Number(usdcBombInfo.epochFinish));
      return date;
    } else {
      return date;
    }
  }, [usdcBombInfo]);

  const discountCave = useMemo(() => {
    return tombPriceInFTM ? (Number(tombPriceInFTM) / 0.025 - 1) * 100 : 0;
  }, [tombPriceInFTM]);

  return (
    <HomeOut>
      <HomeBack>Scrub Money</HomeBack>
      <HomeBody>
        {/*<Link to="/singlestake">
          <CardImg style={{ alignContent:'center', width: '20%' }} src={tigerLogo} />
        </Link>
  */}
        <TotalText>Total Value Locked</TotalText>
        <TotalNumber>
          {!TVL && <CustomLoader color="#ff8718" size={Sizes.MEDIUM} />}
          {TVL > 0 && <CountUp redraw={false} end={TVL} separator="," prefix="$" />}
        </TotalNumber>
        <TotalText>Latest News</TotalText>
        <News>
          <a href="https://medium.com/@scrubmoney/4f1935e253a">
            <List bb={true}>
              ScrubMoney x Bybit Partnership!
              <CardImg style={{ width: '100%' }} src={bybitBanner} />
            </List>
          </a>
          <Link to="/singlestake">
            <List bb={true}>
              Scrub Money Tiger Single Stake is Live!
              <CardImg style={{ width: '40%' }} src={tigerLogo} />
            </List>
          </Link>
          <Link to="/nftcollection">
            <List bb={true}>
              Scrub Money NFT Live!
              <CardImg style={{ width: '100%' }} src={lionNFTLogo} />
            </List>
          </Link>
          <List bb={true}>
            Scrub Money starts Lion Backing Fund!
            <CardImg style={{ width: '100%' }} src={lionFundLogoBack} />
          </List>
          <List bb={true}>
            Scrub Money migrated to Kava Network!
            <CardImg style={{ width: '100%' }} src={kavaLogo} />
          </List>
          <a
            href="https://medium.com/@scrubmoney/scrub-has-acquired-cronos-casino-146fdec14f85"
            target="_blank"
            rel="noopener noreferrer"
          >
            <List bb={true}>
              Scrub Money acquires Cronos Casino!
              <CardImg src={scrubcasino} />
            </List>
          </a>
          <a
            href="https://medium.com/@scrubmoney/dexioprotocol-launchpad-40788a32ec87"
            target="_blank"
            rel="noopener noreferrer"
          >
            <List bb={true}>
              Dexioprodocol Launchpad on Scrub Money
              <CardImg src={scrubDexi} />
            </List>
          </a>
          <a
            href="https://medium.com/@scrubmoney/new-pool-arriving-for-lion-bd0057f00ac9"
            target="_blank"
            rel="noopener noreferrer"
          >
            <List bb={true}>
              Single stake LION Pool activated!
              <CardImg src="https://miro.medium.com/max/1400/1*lBz8SAP46h4jb9ZKKIFm1g.jpeg" />
            </List>
          </a>
        </News>
        <LionRow>
          <LionColumn>
            <Link to="/lionbomb">
              <TotalText>Lion Bomb is burning!</TotalText>
              <CardImgSmall src={lionBombLogo} />
              <CText>Jackpot: {lionBombJackpot} LION </CText>
              <CText>
                {' '}
                <ProgressCountdown
                  base={moment().toDate()}
                  hideBar={false}
                  deadline={lionBombTime}
                  description="Time left"
                />
              </CText>
            </Link>
          </LionColumn>
          <LionColumn>
            <a href="https://tin.network/en/dashboard/preview/0x932A3FE07002D0B98A2Dec0B70beE186b0b37c80">
              <TotalText>Lion Fund is live!</TotalText>
              <CardImgSmall src={lionFundLogo} />
              <CText>Current fund value: {tinBalance}$ </CText>
              <CText>
                Ratio: {formatNumber((tinBalance / (tombCirculatingSupply * tombPriceInDollars)) * 100, 3)} %{' '}
              </CText>
            </a>
          </LionColumn>
          <LionColumn>
            <Link to="/lionbomb">
              <TotalText>USDC Bomb is burning!</TotalText>
              <CardImgSmall src={usdcBombLogo} />
              <CText>Jackpot: {usdcBombJackpot} USDC </CText>
              <CText>
                {' '}
                <ProgressCountdown
                  base={moment().toDate()}
                  hideBar={false}
                  deadline={usdcBombTime}
                  description="Time left"
                />
              </CText>
            </Link>
          </LionColumn>
        </LionRow>
        <LionRow>
          <LionColumn>
            <Link to="/lioncave">
              <TotalText>Lion Cave is Open!</TotalText>
              <CardImgSmall src={lionCave} />
              <CText>Buy LION at a fixed value!</CText>
              <CText>Fixed price per LION: {1 / 40} USDC </CText>
              <CText>Buy from Lion Cave when overpeg </CText>
              <CText>Receive discounted LION!</CText>
              {discountCave > 0 ? <CText>Current cave discount: {discountCave.toFixed(2)}% </CText> : <></>}
            </Link>
          </LionColumn>
          <LionColumn>
            <a href="https://commerce.scrub.money">
              <TotalText>Scrub Commerce is Live!</TotalText>
              <CardImgSmall src={lionPayLogo} />
              <CText>Buy giftcards with your LION!</CText>
              <CText>Take advantage of our exclusive deals </CText>
              <CText>Directly from LION to giftcard! </CText>
              <CText>No conversion tax, cheap and easy!</CText>
            </a>
          </LionColumn>
        </LionRow>
        <Lists>
          <List bb={true}>LION Pegged to the price of 0.025 USDC via Seigniorage</List>
          <List bb={true}>BEAR Pegged to the Price of 0.0033 WBTC via Seigniorage</List>
          <List bb={true}>Stake your Lion-USDC LP and Bear-WBTC LP Tokens</List>
          <List bb={false}>To Maximize profits, Stake your TIGER in SCRUB to Earn more LION and BEAR!</List>
        </Lists>

        <BuyBtns>
          <BuyLeft>
            <BuyBtn>
              <a
                href={
                  chainId.chainId == 25
                    ? 'https://app.firebird.finance/swap?inputCurrency=0xc21223249ca28397b4b6541dffaecc539bff0c59&&outputCurrency=0x49fB98F9b4a3183Cd88e7a115144fdf00fa6fB95'
                    : 'https://equilibrefinance.com/swap'
                }
                rel="noopener noreferrer"
                target="_blank"
              >
                <OutlineBtn width="100%" height="40px" text="BUY LION" clickFunc={noop} />
              </a>
            </BuyBtn>
            <BuyBtn>
              <a
                href={
                  chainId.chainId == 25
                    ? 'https://app.firebird.finance/swap?inputCurrency=0xc21223249ca28397b4b6541dffaecc539bff0c59&&outputCurrency=0xD6597AA36DD90d7fCcBd7B8A228F2d5CdC88eAd0'
                    : 'https://equilibrefinance.com/swap'
                }
                rel="noopener noreferrer"
                target="_blank"
              >
                <OutlineBtn width="100%" height="40px" text="BUY TIGER" clickFunc={noop} />
              </a>
            </BuyBtn>
            <BuyBtn>
              <a
                href={
                  chainId.chainId == 25
                    ? 'https://app.firebird.finance/swap?inputCurrency=0x062e66477faf219f25d27dced647bf57c3107d52&&outputCurrency=0xaa22aebd60c9eb653a0ae0cb8b7367087a9b5dba'
                    : 'https://equilibrefinance.com/swap'
                }
                rel="noopener noreferrer"
                target="_blank"
              >
                <OutlineBtn width="100%" height="40px" text="BUY BEAR" clickFunc={noop} />
              </a>
            </BuyBtn>
          </BuyLeft>
          <BuyRight>
            <a
              href={
                chainId.chainId == 25
                  ? 'https://defined.fi/cro/0xf2059ed015ec4ecc80f902d9fdbcd2a227bfe037?cache=b9e50'
                  : 'https://dexscreener.com/kava/0x09d6561b3795ae237e42f7adf3dc83742e10a2e8'
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <BuyBtn>
                <OutlineBtn width="100%" height="40px" text="LION CHART" clickFunc={noop} />
              </BuyBtn>
            </a>
            <a
              href={
                chainId.chainId == 25
                  ? 'https://defined.fi/cro/0xf6464c80448d6ec4deb7e8e5ec95b8eb768fbf69?cache=abc43'
                  : 'https://dexscreener.com/kava/0xa3c6a2f6d67354f43a0b5ec9e46467822750968c'
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <BuyBtn>
                <OutlineBtn width="100%" height="40px" text="TIGER CHART" clickFunc={noop} />
              </BuyBtn>
            </a>
            <a
              href={
                chainId.chainId == 25
                  ? 'https://defined.fi/cro/0x3d9e539fa44b970605658e25d18f816ce78c4007?cache=267de'
                  : 'https://dexscreener.com/kava/0x78ef6d3e3d0da9b2248c11be11743b4c573add25'
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <BuyBtn>
                <OutlineBtn width="100%" height="40px" text="BEAR CHART" clickFunc={noop} />
              </BuyBtn>
            </a>
          </BuyRight>
        </BuyBtns>
        <LionCardsOut>
          <LionCards>
            <LionCard>
              <CardImg src={lionLogo} alt="" />
              <SubText>LION</SubText>
              <CardMoney>${formatNumber(tombPriceInFTM, 4, 4)}</CardMoney>
              <CardTbl>
                <CardTblLabel>
                  <span>Total Supply</span>
                  {formatNumber(tombCirculatingSupply)}
                </CardTblLabel>
                <CardTblLabel>
                  <span>Liquidity</span>${formatNumber(tombLPStats?.totalLiquidity)}
                </CardTblLabel>
              </CardTbl>
            </LionCard>

            <LionCard>
              <CardImg src={tigerLogo} alt="" />
              <SubText>TIGER</SubText>
              <CardMoney>[${formatNumber(tSharePriceInDollars, 4)}]</CardMoney>
              <CardTbl>
                <CardTblLabel>
                  <span>Total Supply</span>
                  {formatNumber(tShareTotalSupply, 0)}
                </CardTblLabel>
                <CardTblLabel>
                  <span>Liquidity</span>${formatNumber(tshareLPStats?.totalLiquidity)}
                </CardTblLabel>
              </CardTbl>
            </LionCard>

            <LionCard>
              <CardImg src={bearLogo} alt="" />
              <SubText>BEAR</SubText>
              <CardMoney>${formatNumber(bearStats?.tokenInFtm, 8)}</CardMoney>
              <CardTbl>
                <CardTblLabel>
                  <span>Total Supply</span>
                  {formatNumber(bearCirculatingSupply, 0)}
                </CardTblLabel>
                <CardTblLabel>
                  <span>Liquidity</span>${formatNumber(bearLPStats?.totalLiquidity)}
                </CardTblLabel>
              </CardTbl>
            </LionCard>
          </LionCards>
        </LionCardsOut>
      </HomeBody>
      <WarningPart>
        <WarIcon>
          <TiWarning className="warnIcon" />
        </WarIcon>
        <Text>
          Do Your Own Research Before Investing. Investing Is Risky And May Result In Monetary Loss. By using SCRUB, You
          Agree That The Scrub Money Team Is Not Responsible For Any Financial Losses From Investing In Scrub Money.
        </Text>
      </WarningPart>
    </HomeOut>
  );
}
